import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { Switch, Button, CssBaseline, TextField, Typography, Grid, CardContent, FormControlLabel, Radio, MenuItem, Select, Card, Tooltip, RadioGroup, LinearProgress, Checkbox } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Alert from '@mui/material/Alert';
import { useDispatch } from "react-redux";
import { addActivity, } from "../redux/ActionCreator";
import { getCurrentDate } from "../functions/current";
import Multiselect from 'multiselect-react-dropdown';
import config from '../config.json';
import axios from 'axios';
import { bulkUploadImagesToCloudinary } from "../functions/cloudinaryBulkUpload";
import { handleFormChange } from "../functions/multiDropDown";
import { fetchAttributeValues, KeyFillDropDown } from "../functions/helpers/general";
import { checkIfAdmin } from "../functions/helpers/user";
import DraggableImageGrid from '../customComponents/DraggableImageGrid';
const PREFIX = 'create';

const classes = {
  paper: `${PREFIX}-paper`,
  popover: `${PREFIX}-popover`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.paper}`]: {
    fontFamily: "Raleway",
    fontSize: "18",

    marginTop: 20,
  },

  [`& .${classes.popover}`]: {
    pointerEvents: "none",
  }
}));

const token = localStorage.getItem("token");
const userID = parseInt(localStorage.getItem("userID"));

export default function CreatePost() {

  const { id } = useParams();
  // eslint-disable-next-line
  const [actid, setAct] = useState(null);
  const [uniqueIdentifiers, setUniqueIdentifiers] = useState([])
  const [allUniqueIdentifierValues, setAllUniqueIdentifierValues] = useState([])
  const [selectedUniqueIdentifer, setSelectedUniqueIdentifer] = useState('');
  const [masterVolObj, setMasterVolObj] = useState({});
  const [masterRecObj, setMasterRecObj] = useState({});

  const dispatch = useDispatch();
  const [value, setValue] = React.useState("own");
  const [image, setImage] = useState(null);
  const [btn, setBtn] = useState(true);
  const [isLoading, setisLoading] = useState(false)
  const [check, setCheck] = useState('')
  const stringifiedUser = localStorage.getItem('user');
  const user = JSON.parse(stringifiedUser);
  const [val, setVal] = React.useState({
    checkedA: false,
    checkedB: false,
    checkedC: false,
  });
  const [submitHit, setSubmitHit] = useState(false)

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedReceivers, setSelectedReceivers] = useState([]);
  let eventStatusact;
  const [founderID, setFounderID] = useState(0);
  const initialFormData = Object.freeze({
    service_type: "R",
    title: "",
    description: "",
    start_date: "",
    est_hours: "",
    vol_req: "0",
    mother_vol: "0",
    what_donating: "x",
    where_donating: "x",
    category: process.env.REACT_APP_TITLE,
    location: "",
    end_date: "2022-12-12",
    receivers_count: "0",
    fund_links: process.env.REACT_APP_HOST_NAME === 'giftoftime' ? `https://www.${process.env.REACT_APP_HOST_NAME}.in/donate` : `https://www.${process.env.REACT_APP_HOST_NAME}.com/donate`,
    whatsapp_link: "https://www.temporary-url.com/",
    founder_id: founderID
  });

  const [formData, updateFormData] = useState(initialFormData);
  const [errors, setErrors] = useState("");

  const [locations, setLocations] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [schools, setSchools] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [organisations, setOrganisations] = useState([]);

  const handleImageChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setImage((prev) => (prev ? [...prev, ...filesArray] : filesArray));
  };

  const handleRemoveSelectedFile = (indexToRemove) => {
    setImage((prev) => (prev ? prev.filter((_, idx) => idx !== indexToRemove) : []));
  };

  useEffect(() => {


    fetch(
      process.env.REACT_APP_API_URL +
      `/api/program/events/view?program_id=${id}`,
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setFounderID(data.response.response_data[0].FounderId)
      })
      .catch((err) => {
        //console.log(err);
      });

    fetchAttributeValues({ setLocations, setCommunities, setSchools, setCompanies, setOrganisations, model: 'user' })
    getUniqueIdentifiers();
    // eslint-disable-next-line
  }, []);

  async function getUniqueIdentifiers() {

    try {

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: process.env.REACT_APP_API_URL + '/api/user/unique-identifiers/list',
        headers: {
          "Authorization": `Token ${token}`
        }
      };

      const response = await axios(config)

      setUniqueIdentifiers(response.data)

    } catch (err) {

    }

  }

  async function getValuesOfUniqueIdentifier(db_identifier) {

    try {
      setSelectedUniqueIdentifer(db_identifier);

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: process.env.REACT_APP_API_URL + '/api/user/unique-identifiers/values/' + db_identifier,
        headers: {
          "Authorization": `Token ${token}`
        }
      };

      const response = await axios(config)
      let newOptions;
      if (db_identifier === 'community') {
        const communityOptions = communities.map((community) => ({ value: community }));
        newOptions = [...response.data, ...communityOptions];
      } else if (db_identifier === 'school') {
        const schoolOptions = schools.map((school) => ({ value: school }));
        newOptions = [...response.data, ...schoolOptions];
      } else if (db_identifier === 'org_name') {
        const orgOptions = organisations.map((org) => ({ value: org }));
        newOptions = [...response.data, ...orgOptions];
      } else {
        newOptions = response.data;
      }

      newOptions = Array.from(
        new Set(newOptions.map((item) => item.value))
      ).map((value) => ({ value }));

      newOptions.sort((a, b) => a.value.localeCompare(b.value));
      setAllUniqueIdentifierValues(newOptions);

    } catch (err) {

    }

  }

  async function getUsersBasedOnUniqueIdentifier(existingUsers, value) {

    try {

      let data = JSON.stringify({
        value
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: process.env.REACT_APP_API_URL + '/api/user/unique-identifiers/users/' + selectedUniqueIdentifer,
        headers: {
          "Authorization": `Token ${token}`,
          'Content-Type': 'application/json'
        },
        data: data
      };

      const response = await axios(config)

      response.data.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });

      let newSelectedUsers = Array.from(new Set([...existingUsers, ...response.data]))

      newSelectedUsers.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });

      return { newSelectedUsers, valueUsers: response.data };

    } catch (err) {
      return [];
    }

  }

  async function handleBulkAdditionOfUsers(selectedValue, type) {

    let value = selectedValue[selectedValue.length - 1].value;

    if (type === 'volunteer') {

      const { newSelectedUsers, valueUsers } = await getUsersBasedOnUniqueIdentifier(selectedUsers, value)

      if (valueUsers && valueUsers.length > 0) {
        setUsers((prev) => Array.from(new Map([...prev, ...valueUsers].map((u) => [u.id, u])).values()));
      }

      masterVolObj[value] = valueUsers;
      // onVolunteerSelect(newSelectedUsers)
      setMasterVolObj(masterVolObj)

    } else if (type === 'receiver') {

      const { newSelectedUsers, valueUsers } = await getUsersBasedOnUniqueIdentifier(selectedReceivers, value)

      if (valueUsers && valueUsers.length > 0) {
        setUsers((prev) => Array.from(new Map([...prev, ...valueUsers].map((u) => [u.id, u])).values()));
      }

      masterRecObj[value] = valueUsers;
      // onReceiverSelect(newSelectedUsers)
      setMasterRecObj(masterRecObj)

    }

  }

  async function removeSelected(values, type) {

    if (type === 'volunteer') {
      if (values.length === 0) {
        let newArr = [];
        let keyUsers = []
        for (let key of Object.keys(masterVolObj)) {
          keyUsers.push(...masterVolObj[key])
        }

        for (let selectedUser of selectedUsers) {
          let receiverPresent = keyUsers.some(receiver1 => receiver1.id === selectedUser.id)
          if (!receiverPresent) {
            newArr.push(selectedUser)
          }
        }

        // onVolunteerSelect(newArr)
        return;
      }
      let newSelectedUsers = [];

      for (let selectedValue of values) {
        newSelectedUsers.push(...masterVolObj[selectedValue.value])
      }

      newSelectedUsers.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });

      // onVolunteerSelect(newSelectedUsers)
    } else if (type === 'receiver') {
      if (values.length === 0) {
        let newArr = [];
        let keyUsers = []
        for (let key of Object.keys(masterRecObj)) {
          keyUsers.push(...masterRecObj[key])
        }

        for (let receiver of selectedReceivers) {
          let receiverPresent = keyUsers.some(receiver1 => receiver1.id === receiver.id)
          if (!receiverPresent) {
            newArr.push(receiver)
          }
        }

        // onReceiverSelect(newArr)
        return;
      }
      let newSelectedReceivers = [];

      for (let selectedValue of values) {
        newSelectedReceivers.push(...masterRecObj[selectedValue.value])
      }

      newSelectedReceivers.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });

      // onReceiverSelect(newSelectedReceivers)
    }

  }

  // Combining first and last name to display in multiselect option starts
  users && users.forEach(user => {
    user.displayValue = user.first_name + " " + user.last_name;
  });
  // Combining first and last name to display in multiselect option ends

  const handleChange1 = (event) => {
    setValue(event.target.value);
  };

  const checkValid = (data) => {
    let valid = true;
    Object.values(data).forEach((val) => {
      if (val === null || val === undefined) {
        valid = false;
      } else if (typeof val === 'string' || Array.isArray(val)) {
        val.length < 1 && (valid = false);
      }
    });
    return valid;
  };

  const handleVol = (e) => {
    setVal({ ...val, [e.target.name]: e.target.checked });
  };

  const onVolunteerSelect = (selectedItem) => {
    setSelectedUsers(selectedItem);
  }

  const onReceiverSelect = (selectedItem) => {
    setSelectedReceivers(selectedItem);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitHit(true)
    let imagelist = [];

    // Checking the whether event creator is same as program owner starts
    if (parseInt(founderID) === userID || (await checkIfAdmin(userID, token))) {
      eventStatusact = true;
    } else {
      eventStatusact = false;
    }
    // Checking the whether event creator is same as program owner ends

    const body2 = {
      creds:
        (parseInt(formData.vol_req) + parseInt(formData.mother_vol)) *
        formData.est_hours,
      clocked_hours:
        (parseInt(formData.vol_req) + parseInt(formData.mother_vol)) *
        formData.est_hours,
      message: `Wants to create a new event. A little about the event: ${formData.description}`,
      date: "",
      from_user: userID,
      to_user: 1,
      program: id,
      from_username: user["first_name"] + user["last_name"],
      notif_type: "3",
      founderID: founderID
    };

    let selectedUserIds = [];
    for (let selectedUser of selectedUsers) {
      selectedUserIds.push({ id: selectedUser.id });
    }
    let selectedReceiverIds = [];

    for (let selectedUser of selectedReceivers) {
      selectedReceiverIds.push({ id: selectedUser.id });
    }

    if (checkValid(formData)) {
      setisLoading(true);
      setBtn(false);
      const body = {
        service_type: formData.service_type,
        title: formData.title,
        description: formData.description,
        what_donating: formData.what_donating,
        where_donating: formData.where_donating,
        act_status: formData.service_type === "O" ? true : eventStatusact,
        start_date: formData.start_date,
        end_date: formData.end_date,
        est_hours: formData.est_hours,
        vol_req: formData.vol_req ? formData.vol_req : 0,
        category: formData.category,
        location: formData.location,
        community: formData.community,
        school: formData.school,
        company: formData.company,
        mother_vol: formData.mother_vol ? formData.mother_vol : 0,
        is_active: formData.checkedA,
        founder_name: user["first_name"],
        fund_links: formData.fund_links,
        image: imagelist,
        receivers_count: formData.receivers_count,
        whatsapp_link: formData.whatsapp_link,
        user: selectedUserIds,
        receivers: selectedReceiverIds
      };

      if (image) {
        body.image = await bulkUploadImagesToCloudinary(image);
      }
      console.log(body);
      console.log(body2);


      dispatch(addActivity(token, body, setAct, body2, id, setBtn));

    } else {
      setisLoading(false);
      setErrors("Please check if you've entered all the required information.");
      //console.log(getCurrentDate());
      setBtn(true);
    }
  };

  const handleSearch = async (keyWord) => {


    let endPoint = `/api/user/search/${keyWord}`
    try {

      if (keyWord.length > 3) {
        let res = await fetch(process.env.REACT_APP_API_URL + endPoint, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        })
        let data = await res.json()

        setUsers(data)
      }

    } catch (err) {



    }


  }

  if (!isLoading) {
    return (
      <Root className="register" style={{ marginTop: 90 }}>
        <Card>
          <Grid container >
            <Grid item md={2}></Grid>
            <Grid item md={8} xs={12}>
              <CardContent>
                <CssBaseline />
                <div className={classes.paper}>
                  <Grid container className={classes.Typography}>
                    <Grid item md={12}>
                      <Grid container >
                        <Grid item xs={12} style={{ textAlign: "left" }}>
                          <Typography
                            component="h1"
                            style={{
                              borderRadius: 20,
                              fontSize: 36,
                              fontFamily: "Raleway",
                            }}
                          >
                            <strong> CREATE YOUR EVENT </strong>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography className={classes.paper}>
                            <strong>
                              What do you want to call your new event?
                            </strong>
                            <Tooltip
                              title="Example: Trash Mafia Kids, Speak Easy "
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>
                          <TextField
                            variant="outlined"
                            name="title"
                            type="title"
                            id="title"
                            size="small"
                            fullWidth
                            style={{ height: 40 }}
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            error={submitHit && formData.title.length === 0}
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Typography
                            className={classes.paper}
                            style={{ fontFamily: "Raleway" }}
                          >
                            <strong>Describe your social initiative.</strong>
                            <Tooltip
                              title="Example:collecting trash to recycle and raise funds "
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>
                          <TextField
                            variant="outlined"
                            fullWidth
                            multiline
                            name="description"
                            type="description"
                            id="description"
                            size="small"
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            error={submitHit && formData.description.length === 0}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      
                     

                      <Grid container style={{ marginLeft: 2 }}>
                        <Grid
                          item
                          xs={12}
                          style={{
                            textAlign: "left",
                            borderRadius: 20,
                            fontSize: 20,
                            fontFamily: "Raleway",
                          }}
                        >
                          <br></br>
                          <strong>Number of Volunteers required : </strong>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography className={classes.paper}>
                            <strong> Maximum Volunteers :</strong>
                          </Typography>
                          <TextField
                            variant="outlined"
                            required
                            type="number"
                            size="small"
                            name="vol_req"
                            id="vol_req"
                            defaultValue="0"
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            inputProps={{ min: 0 }}
                            error={submitHit && formData.vol_req.length === 0}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography className={classes.paper}>
                            <strong>Maximum Receivers :</strong>
                          </Typography>
                          <TextField
                            variant="outlined"
                            required
                            size="small"
                            name="receivers_count"
                            defaultValue="0"
                            type="number"
                            id="receivers_count"
                            inputProps={{ min: 0 }}
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            error={submitHit && formData.receivers && formData.receivers.length === 0}
                          />
                        </Grid>{" "}
                      </Grid>
                      <Grid item xs={12}></Grid>
                      <Grid container>
                        <Grid item xs={12} md={3}>
                          <Typography className={classes.paper}>
                            <strong>Start date of the event</strong>
                          </Typography>

                          <TextField
                            id="start_date"
                            name="start_date"
                            type="date"
                            size="small"
                            variant="outlined"
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={submitHit && formData.start_date.length === 0}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography className={classes.paper}>
                            <strong>
                              End date of the event
                            </strong>
                          </Typography>

                          <TextField
                            id="end_date"
                            name="end_date"
                            type="date"
                            size="small"
                            variant="outlined"
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={submitHit && formData.end_date.length === 0}
                            inputProps={{ min: getCurrentDate() }}
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Typography className={classes.paper}>
                            <strong> Estimated hours per volunteer </strong>
                          </Typography>
                          <TextField
                            variant="outlined"
                            required
                            id="est_hours"
                            size="small"
                            name="est_hours"
                            type="number"
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                            inputProps={{ min: 0 }}
                            error={submitHit && formData.est_hours.length === 0}
                          />
                        </Grid>
                        {/* <Grid item md={6}>
                          <Typography className={classes.paper}>
                            <strong>Category</strong>
                            <Tooltip
                              style={{ fontSize: 30 }}
                              title=" Choose the category under which your event belongs to   (can be edited later) "
                              arrow
                            >
                              <InfoIcon style={{ color:config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>

                          <Select
                            labelId="demo-simple-select-label"
                            id="category"
                            name="category"
                            fullWidth
                            onChange={handleChange}
                          >
                            <MenuItem value={"Social Cred$"}>
                              Social Cred${" "}
                            </MenuItem>
                          </Select>
                        </Grid> */}
                        <Grid item md={12}>
                          <Typography className={classes.paper}>
                            <strong>How the event credit works? </strong>
                            <Tooltip
                              title=" If you want to offer time cred$ to the volunteers, Gift of time admin will provide your event with credits based on the info provided "
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>

                          <Select
                            error={submitHit && formData.service_type.length === 0}
                            labelId="demo-simple-select-label"
                            name="service_type"
                            fullWidth
                            defaultValue={formData.service_type}
                            onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                          >
                            <MenuItem value={"R"}>
                              I am offering time cred$ to the volunteers
                            </MenuItem>
                            <MenuItem value={"O"}>
                              I am offering my time to earn time credits {" "}
                            </MenuItem>
                          </Select>
                        </Grid>
                        <Grid container>
                          {/* <Grid item xs={12} md={9} >
                            <Typography className={classes.paper}>
                              <strong>Where are you hosting this event?</strong>
                              <Tooltip
                                style={{ fontSize: 30 }}
                                title=" Choose the entity where this event is taking place "
                                arrow
                              >
                                <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                              </Tooltip>
                            </Typography> */}

                          {/* <FormControlLabel control={<Checkbox onChange={(e) => {setCheck(e.target.checked?'community':"")}}  style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />} label="Community" value="community" />
                            <FormControlLabel control={<Checkbox onChange={(e) => {setCheck(e.target.checked?'school':"")}}   style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />} label="School/College" value="school" />
                            <FormControlLabel control={<Checkbox onChange={(e) => {setCheck(e.target.checked?'compamny':"")}}   style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />} label="Company/Corporate" value="company" />
                            <FormControlLabel  control={<Checkbox onChange={(e) => {setCheck(e.target.checked?'ngo':"")}}  style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />} label="NGO/Non-Profits" value="org_name" /> */}

                          {/* <FormControlLabel
                              control={
                                <Checkbox
                                  checked={check === 'community'}
                                  onChange={() => setCheck(check === 'community' ? '' : 'community')}
                                  style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
                                />
                              }
                              label="Community"
                              value="community"
                            /> */}
                          {/* <FormControlLabel
                              control={
                                <Checkbox
                                  checked={check === 'school'}
                                  onChange={() => setCheck(check === 'school' ? '' : 'school')}
                                  style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
                                />
                              }
                              label="School/College"
                              value="school"
                            /> */}
                          {/* <FormControlLabel
                              control={
                                <Checkbox
                                  checked={check === 'company'}
                                  onChange={() => setCheck(check === 'company' ? '' : 'company')}
                                  style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
                                />
                              }
                              label="Company/Corporate"
                              value="company"
                            /> */}
                          {/* <FormControlLabel
                              control={
                                <Checkbox
                                  checked={check === 'ngo'}
                                  onChange={() => setCheck(check === 'ngo' ? '' : 'ngo')}
                                  style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
                                />
                              }
                              label="NGO/Non-Profits"
                              value="org_name"
                            />


                          </Grid>
                        </Grid> */}
                          {/* <Grid container>
                          {check === 'community' &&
                            <Grid container>
                              <Grid item xs={12} md={4} >
                                <Typography className={classes.paper}>
                                  <strong>Select the Community</strong>
                                </Typography>
                                <KeyFillDropDown
                                  options={communities}
                                  keyName="community"
                                  formData={formData}
                                  updateFormData={updateFormData}
                                  handleFormChange={handleFormChange}
                                />
                              </Grid>
                            </Grid>} */}
                          {/* {check === 'school' &&
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <Typography className={classes.paper}>
                                  <strong>Select the School/College</strong>
                                </Typography>
                                <KeyFillDropDown
                                  options={schools}
                                  keyName="school"
                                  formData={formData}
                                  updateFormData={updateFormData}
                                  handleFormChange={handleFormChange}
                                />
                              </Grid>
                            </Grid>} */}
                          {/* {check === 'company' &&
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <Typography className={classes.paper}>
                                  <strong>Select the Company/Corporate</strong>
                                </Typography>
                                <KeyFillDropDown
                                  options={companies}
                                  keyName="company"
                                  formData={formData}
                                  updateFormData={updateFormData}
                                  handleFormChange={handleFormChange}
                                />
                              </Grid>
                            </Grid>} */}
                          {/* {check === 'ngo' &&
                            <Grid container>
                              <Grid item xs={12} md={4} >
                                <Typography className={classes.paper}>
                                  <strong>Select the NGO/Non-Profits</strong>
                                </Typography>
                                <KeyFillDropDown
                                  options={organisations}
                                  keyName="org_name"
                                  formData={formData}
                                  updateFormData={updateFormData}
                                  handleFormChange={handleFormChange}
                                />
                              </Grid>
                            </Grid>} */}


                          <Grid item xs={12} md={4}>
                            <Typography className={classes.paper}>
                              <strong>Location</strong>
                              <Tooltip style={{ fontSize: 30 }} title="Choose the geo location" arrow>
                                <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                              </Tooltip>
                            </Typography>
                            <KeyFillDropDown
                              options={locations}
                              keyName="location"
                              formData={formData}
                              updateFormData={updateFormData}
                              handleFormChange={handleFormChange}
                            />
                          </Grid>
                        </Grid>
                      </Grid>


                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                          <Typography className={classes.paper}>
                            <strong>Entity your volunteers belong to</strong>
                            <Tooltip
                              style={{ fontSize: 30 }}
                              title="Choose any entity your volunteers/receivers belong to"
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>
                          <Select
                            labelId="demo-simple-select-label"
                            size="small"
                            onChange={(e) => { getValuesOfUniqueIdentifier(e.target.value) }}
                            fullWidth
                            defaultValue={""}
                          >

                            {uniqueIdentifiers.map(identifier =>
                              <MenuItem key={identifier.db_identifier} value={identifier.db_identifier}>
                                {identifier.name}
                              </MenuItem>
                            )}
                          </Select>
                        </Grid>

                        <Grid item md={5} xs={12}>
                          <Typography className={classes.paper}>
                            <strong>Choose Entities for Volunteers</strong>
                            <Tooltip
                              style={{ fontSize: 30 }}
                              title="Choose Entity Name for Volunteers"
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>

                          <Multiselect
                            options={allUniqueIdentifierValues}
                            onSelect={(e) => { handleBulkAdditionOfUsers(e, 'volunteer') }}
                            displayValue="value"
                            onRemove={(e) => { removeSelected(e, 'volunteer') }}

                          />
                        </Grid>
                        <Grid item md={3}>
                          <Typography className={classes.paper}>
                            <strong>Can't find your community or want to add yourself to one?</strong>
                          </Typography>
                          <Button
                            variant="contained"
                            style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}

                            onClick={() => window.location.href = '/edit/profile'}
                          >
                            Add Entity
                          </Button>
                        </Grid>
                      </Grid>

                      <Grid item md={9} xs={12}>
                        <Typography className={classes.paper}>
                          <strong>Choose Volunteers</strong>
                          <Tooltip
                            style={{ fontSize: 30 }}
                            title="Choose volunteers from dropdown list"
                            arrow
                          >
                            <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                          </Tooltip>
                        </Typography>

                        <Multiselect
                          options={users} // Options to display in the dropdown
                          onSelect={onVolunteerSelect} // Function will trigger on select event
                          onRemove={onVolunteerSelect}
                          selectedValues={selectedUsers}
                          onSearch={(e) => { handleSearch(e) }}
                          placeholder="Search by name/community"
                          displayValue="displayValue" // Property name to display in the dropdown options
                        />
                      </Grid>

                      <Grid container spacing={3}>

                        <Grid item xs={12} md={4}>
                          <Typography className={classes.paper}>
                            <strong>Entity your receivers belong to</strong>
                            <Tooltip
                              style={{ fontSize: 30 }}
                              title="Choose any entity your receivers belong to"
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>
                          <Select
                            labelId="demo-simple-select-label"
                            size="small"
                            onChange={(e) => { getValuesOfUniqueIdentifier(e.target.value) }}
                            fullWidth
                            defaultValue={""}
                          >
                            {uniqueIdentifiers.map(identifier =>
                              <MenuItem key={identifier.db_identifier} value={identifier.db_identifier}>
                                {identifier.name}
                              </MenuItem>
                            )}
                          </Select>
                        </Grid>
                        <Grid item md={5} xs={12}>
                          <Typography className={classes.paper}>
                            <strong>Choose Entities for Receivers</strong>
                            <Tooltip
                              style={{ fontSize: 30 }}
                              title="Choose Receivers"
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>

                          <Multiselect
                            options={allUniqueIdentifierValues} // Options to display in the dropdown
                            onSelect={(e) => { handleBulkAdditionOfUsers(e, 'receiver') }} // Function will trigger on select event
                            displayValue="value"// Property name to display in the dropdown options
                            onRemove={(e) => { removeSelected(e, 'receiver') }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3} >
                        <Grid item md={9} xs={12} >
                          <Typography className={classes.paper}>
                            <strong>Choose Receivers</strong>
                            <Tooltip
                              style={{ fontSize: 30 }}
                              title="Choose Receivers"
                              arrow
                            >
                              <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                            </Tooltip>
                          </Typography>

                          <Multiselect
                            options={users} // Options to display in the dropdown
                            onSelect={onReceiverSelect} // Function will trigger on select event
                            onRemove={onReceiverSelect}
                            selectedValues={selectedReceivers}
                            displayValue="displayValue" // Property name to display in the dropdown options
                            onSearch={(e) => { handleSearch(e) }}
                            placeholder="Search by name/community"
                          />
                        </Grid>
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12}></Grid>

                      </Grid>
                      <Grid item xs={12} style={{ fontSize: 20 }}>
                        <Switch
                          checked={val.checkedC}
                          onChange={handleVol}
                          name="checkedC"
                          color="default"
                          style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />{" "}
                        Do you want to ask for donation from users?
                      </Grid>
                      {val.checkedC ? (
                        <Grid style={{ marginLeft: 2 }} container spacing={4}>
                          <RadioGroup
                            aria-label="gender"
                            name="gender1"
                            value={value}
                            onChange={handleChange1}
                          >
                            <Grid container style={{ marginTop: 30 }}>
                              <Grid item md={12}>
                                <FormControlLabel
                                  value="offer"
                                  control={<Radio color="primary" />}
                                  style={{ fontFamily: "Raleway" }}
                                  label="Use the Gift of time donate button"
                                  labelPlacement="end"
                                />
                                <Button
                                  style={{
                                    textTransform: "None",
                                    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                    color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                    borderRadius: 20,
                                    width: 100,
                                    height: 40,
                                    fontFamily: "Raleway",
                                  }}
                                  disabled
                                >
                                  Donate
                                </Button>
                              </Grid>
                              <Grid item md={6}>
                                <FormControlLabel
                                  value="own"
                                  control={<Radio color="primary" />}
                                  label="I have my own donation link"
                                  labelPlacement="end"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                          {value === "own" ? (
                            <Grid item md={8} xs={12}>
                              <Typography className={classes.paper}>
                                <strong>
                                  Enter your donation link below :{" "}
                                </strong>
                              </Typography>
                              <TextField
                                variant="outlined"
                                fullWidth
                                multiline
                                size="small"
                                name="fund_links"
                                onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                              />
                              <br></br>
                              <br></br>
                            </Grid>
                          ) : (
                            ""
                          )}
                        </Grid>
                      ) : (
                        " "
                      )}
                      <Grid item md={5} xs={12}>
                        <Typography className={classes.paper}>
                          <strong>
                            Enter your whatsapp group invite link below (optional) :(Only visible to members of the program once they have been accepted) :{" "}
                          </strong>
                        </Typography>
                        <TextField
                          variant="outlined"
                          fullWidth
                          multiline
                          size="small"
                          name="whatsapp_link"
                          onChange={(e) => { handleFormChange(e.target.value, e.target.name, formData, updateFormData); }}
                        />
                        <br></br>
                        <br></br>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8, textAlign: "left", marginTop: 10 }}>
                          Upload your event images
                        </Typography>
                        <div style={{ textAlign: "left" }}>
                          <input
                            type="file"
                            id="image"
                            accept="image/png, image/jpeg, image/jpg"
                            multiple
                            onChange={handleImageChange}
                            style={{ border: "none", outline: "none", cursor: "pointer" }}
                          />
                        </div>
                        <DraggableImageGrid
                          items={image || []}
                          onReorder={(newFiles) => setImage(newFiles)}
                          onDelete={(idx) => handleRemoveSelectedFile(idx)}
                        />
                      </Grid>

                      {errors.length > 0 ? (
                        <Alert
                          severity="error"
                          style={{ fontFamily: "Raleway" }}
                        >
                          {" "}
                          {errors}
                        </Alert>
                      ) : null}

                      <Grid item xs={12} md={12}>
                        <br></br>
                        {btn ? (
                          <Button
                            type="submit"
                            variant="contained"
                            style={{
                              backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                              color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                              borderRadius: 30,
                              fontFamily: "Raleway",
                              marginBottom: 30,

                            }}
                            onClick={handleSubmit}
                          >
                            create event
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            variant="contained"
                            style={{
                              color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                              borderRadius: 30,
                              fontFamily: "Raleway",
                              marginBottom: 30,
                              backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                              height: 40,
                              marginTop: 20
                            }}
                            onClick={handleSubmit}
                            disabled
                          >
                            create event
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </CardContent>
            </Grid>
            <Grid item md={2}></Grid>
          </Grid>
        </Card>
      </Root >
    );
  } else {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </div>
    );
  }
}
